import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { ServiceUnavailableBanner } from '@/components/common';

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <React.StrictMode>
      <BrowserRouter>
        {children}
        <ServiceUnavailableBanner />
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </React.StrictMode>
  );
}
